import React from 'react';
import {
  Divider,
} from '@roo/roo';
import { getLableByValue } from '@utils/positionTitle';
import { renderDetailByColumns, renderDetailListByColumns } from './util';

import '../index.scss';

const schoolList = ['学士', '硕士', '博士'];

const personColumns = [{
  key: 'name',
  label: <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>,
}, {
  key: 'idCardNo',
  label: '身份信息',
}, {
  key: 'birthday',
  label: '出生日期',
}, {
  key: 'phone',
  label: '手机号码',
}, {
  key: 'email',
  label: '联系邮箱',
}, {
  key: 'companyName',
  label: '单位名称',
},
{
  key: 'position',
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</span>,
},
{
  key: 'positionalTitle',
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</span>,
  _render: (record) => {
    const { positionalTitle } = record;
    return <span className="control-field">{getLableByValue(positionalTitle)}</span>;
  },
},
];
/** 评审端个人信息 */
const reviewPersonColumns = [
  {
    key: 'name',
    label: <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>,
  },
  {
    key: 'companyName',
    label: '单位名称',
  },
];

const eduColumns = [{
  key: 'startTime',
  label: <span>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>,
  _render: (info) => <span className="control-field">{`${info.startTime}-${info.endTime}`}</span>,
}, {
  key: 'collegeName',
  label: <span>学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校</span>,
}, {
  key: 'major',
  label: <span>专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业</span>,
}, {
  key: 'degreeType',
  label: '学位类型',
  _render: (record) => {
    const { degreeType } = record;
    return schoolList[Number(degreeType) - 1];
  },
}, {
  key: 'mentor',
  label: <span>导&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;师</span>,
}];
/** 评审端教育经历 */
const reviewEduColumns = [{
  key: 'startTime',
  label: <span>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>,
  _render: (info) => <span className="control-field">{`${info.startTime}-${info.endTime}`}</span>,
}, {
  key: 'collegeName',
  label: <span>学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校</span>,
}, {
  key: 'major',
  label: <span>专&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业</span>,
}, {
  key: 'degreeType',
  label: '学位类型',
  _render: (record) => {
    const { degreeType } = record;
    return schoolList[Number(degreeType) - 1];
  },
}];
const workColumns = [{
  key: 'startTime',
  label: <span>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>,
  _render: (info) => <span className="control-field">{`${info.startTime}-${info.endTime}`}</span>,
}, {
  key: 'companyName',
  label: <span>单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位</span>,
}, {
  key: 'post',
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位</span>,
}, {
  key: 'mentor',
  label: '合作导师',
  required: false,
}];
/** 评审端工作经历 */
const reviewWorkColumns = [{
  key: 'startTime',
  label: <span>时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间</span>,
  _render: (info) => <span className="control-field">{`${info.startTime}-${info.endTime}`}</span>,
}, {
  key: 'companyName',
  label: <span>单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位</span>,
}, {
  key: 'post',
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位</span>,
}];

export default ({ detail: personInfo, isView }) => (
  <>
    <h3 id="person" className="catalogue-tag">个人信息</h3>
    <Divider />
    {
      renderDetailByColumns(personInfo, isView ? reviewPersonColumns : personColumns)
    }
    <div className="preview-label-wrap">
      <h3 id="edu" className="catalogue-tag">教育经历</h3>
      <span className="preview-tips">请按时间倒序填写至本科阶段</span>
    </div>
    <Divider />
    {
      renderDetailListByColumns(personInfo.eduInfo, isView ? reviewEduColumns : eduColumns)
    }
    <h3 id="work" className="catalogue-tag">科研工作经历</h3>
    <Divider />
    {
      renderDetailListByColumns(personInfo.workInfo, isView ? reviewWorkColumns : workColumns)
    }
  </>
);
